<template>
  <div class="content_box">
    <div class="content_box_inner">
      <div class="industryCode" id="ManageTable">
        <div class="industryCode_header">
          <div class="industryCode_logo">
            <img
              style="width: 29px; height: 29px"
              src="@/assets/imgs/icon/icon_examine.png"
              alt
            />
          </div>
          <h3>企业信息修改审核</h3>
        </div>
        <el-tabs v-model="activeName">
          <el-tab-pane label="未办理" name="notReport">
            <not-report v-if="activeName == 'notReport'"></not-report>
          </el-tab-pane>
          <el-tab-pane label="审核未通过" name="pass">
            <notPass v-if="activeName == 'pass'"></notPass>
          </el-tab-pane>
          <el-tab-pane label="审核通过" name="notPass">
            <pass v-if="activeName == 'notPass'"></pass>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import notReport from "./notReport/index";
import notPass from "./notPass/index";
import pass from "./pass/index";
export default {
  components: {
    notReport,
    notPass,
    pass,
  },
  data() {
    return {
      activeName: "notReport",
    };
  },
  methods: {},
};
</script>
<style lang="less" scoped>
.industryCode {
  width: 100%;
  height: 100%;
  padding: 10px 0;
  box-sizing: border-box;

  .industryCode_header {
    height: 31px;
    width: 100%;
    display: flex;
    margin-bottom: 30px;

    .industryCode_logo {
      margin: 2px 20px 0 2px;
    }

    h3 {
      font-size: 24px;
      height: 100%;
      margin: 0;
      color: #444444;
    }
  }

  .industryCode_form {
    height: 70px;
    width: 100%;
    box-sizing: border-box;
    border-bottom: 1px solid rgba(155, 155, 155, 0.25);
    margin-bottom: 20px;

    .el-form {
      .el-form-item {
        margin-right: 30px;
      }
    }
  }

  .industryCode_add_user {
    margin-bottom: 20px;
  }

  .el-dialog {
    .addUser {
      .el-form-item {
        .el-select {
          width: 100%;
        }
      }
    }
  }
}

.detail {
  width: 100%;
  height: 100%;
  cursor: pointer;
  color: #5584ff;
}
.content_box {
  padding: 20px 30px 30px;
}

.content_box_inner {
  padding: 10px 20px 20px;
  box-shadow: 0px 0px 50px #ccc;
}

@media (max-width: 1200px) {
  .content_box {
    padding: 20px 10px 30px;
  }
  .content_box_inner {
    padding: 10px 10px 20px;
  }
}
</style>